import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * GetTagHistory
 *
 * Get the trend data for tags.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetTagHistory = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: thePayload,
      headers: {
        'x-api-endpoint': '/dashboard/operational/tag-trend',
      },
      method: 'POST',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse?.data;
  } catch (error) {
    logger.error('src/entities/Tag/api/requests/queries/GetTagHistory.js -> GetTagHistory()', false, error);

    throw error;
  }
};
